import React, { useState, useEffect, useContext } from 'react';


import SimpleTable from '../../components/tables/simpleTable';

import TrashModal from '../../components/modals/trashModal';
import RecoverModal from '../../components/modals/recoverModal';
import AddModal from '../../components/modals/addModal';
import EditModal from '../../components/modals/editModal';
import DeleteModal from '../../components/modals/deleteModal';

import SearchFilter from '../../components/filters/search';
import CustomButton from '../../components/buttons/customButton';
import IsActiveFilter from '../../components/filters/isActive';
import AddButton from '../../components/buttons/addButton';
import DatePicker from '../../components/filters/datePicker';
import DropDownFilter from '../../components/filters/dropDownFilter';
import AsyncDropDownFilter from '../../components/filters/asyncDropdownFilter';

import { FaPlus } from "react-icons/fa";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter } from '../../components/formatters/numberFormatter';
import { clientOrderColumnDefs } from '../../components/tables/columnDefs';
import { dateTableFormatter } from '../../dynamic/dateFormatter';
import { typeFormatter, productSalesFormatter } from '../../components/formatters/defFormatter';
import { dateFormatter, dateViewerFormatter } from '../../dynamic/dateFormatter';

import toast from 'react-hot-toast';

import { Space, Input, Tag, Button, Tabs } from 'antd';


import Select from 'react-select';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcViewDetails, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiBarcodeReader } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";



import { DataContext } from '../../init/getData';




function ProductSales(props) {

  let { } = props;


  const { userData, settingData, api, devData, refWareHouseData, refCategory, categoryData, refProductData, productData, refAllUserData, allUserData } = useContext(DataContext);


  const [loadingCounter, setLoadingCounter] = useState(0);
  const [data, setData] = useState([]);

  const createdBy = parseInt(userData.id);
  const userRole = userData.role;
  const defaultWareHouseId = userData?.role?.defaultWareHouseId;

  const today = new Date().toISOString().split('T')[0];


  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);

  const [filter, setFilter] = useState({
    search: '', isActive: 'true', fromDate: today, toDate: today, isOrder: false,
    productId: null, wareHouseId: defaultWareHouseId, transactionType: null, categoryId: null, createdBy: null
  });

  const [showAddModal, setShowAddModal] = useState(false);
  const [showTrashModal, setShowTrashModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);


  const [name, setName] = useState('');
  const [category, setCategory] = useState([]);

  const table = 'productSales';
  const title = 'ProductSalesByItem';



  const addModal = () => {
    setIdRow({});
    resetForm();
    setShowAddModal(!showAddModal);
  }

  const resetForm = () => {
    setCategory({ createdBy: createdBy })
  }

  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const trashModal = (e) => {
    if (!showTrashModal) {
      setIdRow(e);
    }
    setShowTrashModal(!showTrashModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }

  const editModal = (e) => {
    if (!showEditModal) {
      setIdRow(e);
    }
    setShowEditModal(!showEditModal);
  }

  // idRow Change
  useEffect(() => {
    setCategory(
      {
        name: idRow?.name || '',
        createdBy: createdBy,
      }
    )
  }, [idRow]);




  //Excel Data
  const getExcelData = (data, getSummary) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        id: item.id,
        createdAt: item.createdAt,
        barcode: item.product?.barcode,
        name: item.product?.name,
        quantity: item.quantity,
        type: item.transaction?.type,
        cost: item.cost,
        profit: item.profit,
      };

      transformedData.push(newItem);
    });

    const summary = {
      TotalSales: getSummary.totalSales,
      TotalCost: getSummary.totalCost,
      TotalDiscounts: getSummary.totalDiscounts,
      TotalProfit: getSummary.totalProfit,
    }
    return { transformedData, summary };
  };


  let newColumnDefs = [
    { title: 'CreatedAt', dataIndex: 'createdAt', render: dateTableFormatter },
    { title: 'Date', dataIndex: 'transaction', render: (transaction) => (transaction?.date) },
    { title: 'Barcode', dataIndex: 'product', render: (product) => (product?.barcode), width: '12%' },
    { title: 'Product', dataIndex: 'product', render: (product) => (product?.name) },
    { title: 'Qty', dataIndex: 'quantity', render: (quantity, record) => (numberFormatter(quantity, 2) + ' ' + record?.product?.unit) },
    { title: 'Type', dataIndex: 'transaction', render: productSalesFormatter },
    { title: 'Total', dataIndex: 'totalPrice', render: numberFormatter },
    { title: 'Cost', dataIndex: 'cost', render: numberFormatter },
    { title: 'Profit', dataIndex: 'profit', render: numberFormatter },
  ];


  useEffect(() => {

    setColumnDefs(newColumnDefs);

  }, []);


  const formView = (
    <div style={{ userSelect: 'none' }}>
    </div >);




  const modalFooter = (
    <div>
    </div>
  );

  const tableFooter = (

    <div style={{ display: 'flex', justifyContent: 'space-between', position: 'absolute', left: '35%', transform: 'translateX(-30%)' }}>
      <div>
        <span className='table-footer footer-one'>Total Items Sold: {numberFormatter(data?.summary?.totalItems, 2)}</span>
        <span className='table-footer footer-green'>Total Sales: {numberFormatter(data?.summary?.totalSales, 2)}{settingData.currency}</span>
        <span className='table-footer footer-red'>Total Cost: {numberFormatter(data?.summary?.totalCost, 2)}{settingData.currency}</span>
        <span className='table-footer footer-yellow'>Total Discounts: {numberFormatter(data?.summary?.totalDiscounts, 2)}{settingData.currency}</span>
        <span className='table-footer footer-green'>Total Profit: {numberFormatter(data?.summary?.totalProfit, 2)}{settingData.currency}</span>
      </div>
    </div>

  );


  return (
    <div className='card'>


      <div>

        <DatePicker setFilter={setFilter} filter={filter} />
        <DropDownFilter setFilter={setFilter} filterBy={'categoryId'} placeHolder={'All Category'} filter={filter} setLoadingCounter={() => setLoadingCounter((prevCounter) => prevCounter + 1)} />
        <AsyncDropDownFilter 
        setFilter={setFilter} 
        filterBy={'productId'} 
        placeHolder={'All Product'} 
        filter={filter} 
        setLoadingCounter={() => setLoadingCounter((prevCounter) => prevCounter + 1)} 
        
    />
        <DropDownFilter setFilter={setFilter} filterBy={'createdBy'} placeHolder={'All User'} filter={filter} setLoadingCounter={() => setLoadingCounter((prevCounter) => prevCounter + 1)} />
        <DropDownFilter setFilter={setFilter} filterBy={'wareHouseId'} placeHolder={'All ' + devData.wareHouseName} filter={filter} setLoadingCounter={() => setLoadingCounter((prevCounter) => prevCounter + 1)} />

      </div>  

      
      {loadingCounter < 4 &&
        <Loader />
      }

      {loadingCounter == 4 &&
        <>



          <SimpleTable
            filter={filter}
            showAddModal={showAddModal}
            addModal={addModal}
            table={table}
            title={title}
            columnDefs={columnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
          />

          <TrashModal
            showModal={showTrashModal}
            toggleModal={trashModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
          />

          <DeleteModal
            showModal={showDeleteModal}
            toggleModal={deleteModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
          />

          <RecoverModal
            showModal={showRecoverModal}
            toggleModal={recoverModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
          />

          <AddModal
            showModal={showAddModal}
            toggleModal={addModal}
            formView={formView}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            size={'md'}
            resetForm={resetForm}
            footer={modalFooter}
            api={api}
            data={{ category }}
          />

          <EditModal
            showModal={showEditModal}
            toggleModal={editModal}
            formView={formView}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            size={'md'}
            footer={modalFooter}
            api={api}
            data={{ id: idRow?.id, category }}
          />

        </>
      }


    </div>
  )
}

export default ProductSales;
